module.exports = __webpack_public_path__ + "static/img/pharmaceuticalEnterprises1.ea5aeff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/pharmaceuticalEnterprises1.png
// module id = O4fV
// module chunks = 1